import { Typography } from "@mui/material"
import { Title } from "./PageTitle.styled"

export const PageTitle = () => {
    return (<Typography variant="mainTitle" component ={Title}>Box maker</Typography>)
}